<template>
  <div class="box6_main">
    <div class="title">一键报警</div>
    <div class="content">
      <div class="content_pad">
        <div class="con_box"><span>{{itemData.total}}</span>设备总数</div>
        <div class="con_box2">
          <div class="line"><span>{{itemData.online}}</span>在线</div>
          <div class="line2"><span>{{itemData.Offline}}</span><em>离线<img src="@/assets/home_images/box6/right_icon.png"></em></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Box6',
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total: 0,
          online: 0,
          Offline: 0
        }
      }
    }
  },
  data() {
    return {
      
    }
  }
};
</script>
<style lang='less' scoped>
.box6_main {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  .title {
    font-size: 18px;
    line-height:30px;
    font-weight: normal;
    color:#fff;
    display: block;
    width:100%;
  }
  .content{
    position: absolute;
    padding-top:35px;
    width:100%;
    height:100%;
    box-sizing: border-box;
    top:0;
    left:0;
    .content_pad{
      width:100%;
      height:100%;
      position: relative;
      background-image:url('../../assets/home_images/box6/main_bor.png');
      background-position:center center;
      background-size:100% 100%;
      background-repeat:no-repeat;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .con_box{
        float: left;
        width:50%;
        height:70%;
        background-image:url('../../assets/home_images/box6/left_img.png');
        background-position:center center;
        background-size:auto 100%;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        align-items: center; 
        flex-direction: column;
        color:#fff;
        font-size:12px;
        border-right:2px solid rgba(255,255,255,.1);
        span{
          display: block;
          color:#6aabfd;
          font-size:32px;
          margin-top: 10px;
          font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
          font-style: normal;
        }
      }

      .con_box2{
        float: left;
        width:50%;
        height:70%;
        display: flex;
        justify-content: center;
        align-items: center; 
        flex-direction: column;
        .line{
          padding: 10px 20px;
          border-bottom:2px solid rgba(255,255,255,.1);
          display: flex;
          justify-content: center;
          align-items: center;
          color:#fff;
          font-size:12px;
          span{
            display: block;
            color:#00a99d;
            font-size:32px;
            margin-right: 10px;
            font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
            font-style: normal;
          }
        }

        .line2{
          padding: 10px 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          color:#fff;
          font-size:12px;
          span{
            display: block;
            color:#d22d5f;
            font-size:32px;
            margin-right: 10px;
            font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
           font-style: normal;
          }
          em{
            font-style: normal;
            margin:0;
            padding:0;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            img{
              width: 26px;
              height: auto;
            }
          }
        }
      
     }
    }
    
  }
  
}


</style>